import { createSlice } from "@reduxjs/toolkit";

const getDefaultYear = () => {
  const today = new Date();

  const currentYear = today.getFullYear();
  const april30 = new Date(currentYear, 3, 30);
  // Up to 30th April => current year
  // After 30th April => next year
  return today <= april30 ? String(currentYear) : String(currentYear + 1);
};

const initialState = {
  customerDetails: [],
  selectedCustomerDetail: JSON.parse(
    localStorage.getItem("selectedCustomerDetail")
  ) || null,
  selectedCustomerSummaryFilters: {
    selectedYear: getDefaultYear(),
    selectedHandler: "",
    selectedKdNumber: "",
    selectedLand: "",
    selectedActive: "A",
    selectedPlanned: "",
    selectedTemplate: "",
    selectedType: "VK",
    selectedVtr: "",
    selectedVtrGroup: "",
    handlerName: "",
  },
};

const CustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    customerSummary: (state, action) => {
      // state.customerDetails.push(action.payload);
      // console.log('action customer', action.payload)
      state.customerDetails = action.payload;
    },

    // NEW reducer
    setSelectedCustomerDetail: (state, action) => {
      state.selectedCustomerDetail = action.payload;
    
      localStorage.setItem(
        "selectedCustomerDetail",
        JSON.stringify(action.payload)
      );
    },

    setSelectedCustomerSummaryFilters: (state, action) => {
      const { key, value } = action.payload;

      state.selectedCustomerSummaryFilters[key] = value;
    },
    resetCustomerSummaryFilters: (state) => {
      state.selectedCustomerSummaryFilters =
        initialState.selectedCustomerSummaryFilters;
    },
  },
});

export const {
  customerSummary,
  setSelectedCustomerDetail,
  setSelectedCustomerSummaryFilters,
  resetCustomerSummaryFilters
} = CustomerSlice.actions;
export default CustomerSlice.reducer;
